import { Component } from '@angular/core';
import { AppService } from './app.service';

@Component({
    moduleId: module.id,
    selector: 'my-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    // title = 'JICS';

    /* CONSTRUCTORS ======================================================== */
    constructor(
        private appService: AppService /* necessary for provide appService */
    ) {}
}